import type { Unit } from '@/types';

export type AlertFilterState = 'none' | 'both' | 'warnings' | 'faults';

/**
 * Determines if a unit matches the current alert filter state
 * @param unit - The unit to check
 * @param alertFilter - The current alert filter state
 * @returns true if the unit matches the filter criteria
 */
export function matchesAlertFilter(unit: Unit, alertFilter: AlertFilterState): boolean {
  if (alertFilter === 'none') {
    return true;
  }

  // Check if unit has alerts
  const hasAlerts = unit.alerts !== undefined && unit.alerts > 0;

  if (!hasAlerts) {
    return false;
  }

  if (alertFilter === 'both') {
    return true;
  }

  if (alertFilter === 'warnings') {
    return unit.alertType === 'warning';
  }

  if (alertFilter === 'faults') {
    return unit.alertType === 'fault';
  }

  return true;
}